export default __webpack_public_path__ + "static/media/Browser.f10e1b2b.png";